import React, { useState, useEffect, forwardRef } from "react";
import "../css/style.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import Logo from "../images/logo.png"
import MarginHeader from "./marginHeader";
import MarginContent from './marginContent'
import callingAPI from "../service"
import MarginTable from "./marginTable";
import NonMarginContent from "./nonMarginContent";
import { useSelector } from "react-redux";
const StatementoffinancialholdingsPdf2 = forwardRef((props, ref) => {
    const dashboardDetails = useSelector((state) => state.Dashboard);

    const reportDetails = useSelector((state) => state.report.nonmarginportfolio);
    const formatDate = (date) => {
        return new Date(date).toISOString().split('T')[0]; // Converts to YYYY-MM-DD format
    };
    const [marginSummery, setMarginSummery] = useState([])
    const [clientAddressDetails, setClientAddressDetails] = useState({
        building: "48 Burj Gate",
        street: "Sheikh Zayed Road",
        citya: "Dubai",
        countrya: "United Arab Emirates",
        officeno: "801",
        trnno: "",
        mobile: "919961727479",
        postbox: "119930"
    });
    const [marginDetails, setMarginDetails] = useState([])
    const [totalMarketValue_AED, setTotalMarketValue_AED] = useState([])
    const [totalcashBalance_AED, setTotalcashBalance_AED] = useState([])
    const [totalnetAssetValue_AED, setTotalnetAssetValue_AED] = useState([])
    const [formattedFromDate, setFormattedFromDate] = useState(() =>
        props.fromDate ? formatDate(props.fromDate) : formatDate(new Date())
    );
    const [formattedToDate, setFormattedToDate] = useState(() =>
        props.toDate ? formatDate(props.toDate) : formatDate(new Date())
    );
    const [cashBalanceDetails, setCashBalanceDetails] = useState([])
    const refreshToken = dashboardDetails.refreshToken;


    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '21cm', // A4 paper height in cm
        width: '100%',
        margin: '0 auto',
        padding: '0 15px 0 15px', // 15px left and right padding, 2cm padding bottom for the footer
        position: 'relative',
        fontFamily: 'Roboto Medium',
        color: '#000',
        fontSize: '13px',
        boxSizing: 'border-box' // Ensures padding doesn't affect the width
    };

    const htmlBodyStyle = {
        width: '100%',
        margin: '0',
        padding: '0',
        overflowX: 'hidden' // Hides horizontal scroll globally
    };

    const headerStyle = {
        // marginBottom: '1cm',
    };

    const mainStyle = {
        flex: '1',
        // marginBottom: '1cm',
    };

    const footerStyle = {
        width: '100%',
        boxSizing: 'border-box',
        borderTop: '2px solid #d5d5d5',
        textAlign: 'center',
        fontSize: '12px',
        padding: '5px',
        position: 'absolute',
        bottom: '-10px',
    };


    const tdStyle = {
        background: '#e0e0e0',
        borderBottom: '1px solid #fff',
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        padding: "4px 5px",
        color: "#000",
        fontSize: '13px',



    }
    const totalTd = {
        fontFamily: "Roboto Black",
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        // padding:"1px",
        fontSize: "13px"
    }
    const total = {
        fontFamily: "Roboto Black",
        fontSize: "13px"
    }

    useEffect(() => {


        console.log("props....", props, ref);
        if (props.fromDate != undefined && props.toDate != undefined) {
            const formattedFromDates = formatDate(props.fromDate);
            const formattedToDates = formatDate(props.toDate);
            setFormattedFromDate(formattedFromDates)
            setFormattedToDate(formattedToDates)
        } else {
            setFormattedFromDate(formatDate(new Date()))
            setFormattedToDate(formatDate(new Date()))
        }
    }, [props.fromDate, props.toDate]);

    useEffect(() => {
        // marginReportList();
        setMarginSummery(reportDetails?.summery || []);
        setClientAddressDetails(reportDetails?.clientAddressDetails || clientAddressDetails); // Use dynamic data or fallback to sample

        setMarginDetails(reportDetails?.details)
        setCashBalanceDetails(reportDetails?.cashBalanceDetails)
        setTotalnetAssetValue_AED(reportDetails?.totalnetAssetValue_AED)
        setTotalcashBalance_AED(reportDetails?.totalavailableCash_AED)
        setTotalMarketValue_AED(reportDetails?.totalmarketValue_AED)
        document.documentElement.style.cssText = `width: 100%; margin: 0; padding: 0; overflow-x: hidden;`;
        document.body.style.cssText = `width: 100%; margin: 0; padding: 0; overflow-x: hidden;`;
    }, [reportDetails]);
    const marginReportList = () => {
        const clientId = dashboardDetails.clientid;
        const userId = dashboardDetails.userId
        const postData = {
            "userId": userId,
            "fromDate": props.fromDate != undefined ? formatDate(props.fromDate) : formatDate(new Date()),
            "toDate": props.toDate != undefined ? formatDate(props.toDate) : formatDate(new Date()),
            "clientId": clientId,
            //"refreshToken": refreshToken
        }
        callingAPI(postData, "reports/getNonMarginPortfolio", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    const dataValue = data.data
                    setMarginSummery(dataValue.summery || []);
                    setClientAddressDetails(dataValue.clientAddressDetails)
                    setMarginDetails(dataValue.details)
                    setCashBalanceDetails(dataValue.cashBalanceDetails)
                    setTotalnetAssetValue_AED(dataValue.totalnetAssetValue_AED)
                    setTotalcashBalance_AED(dataValue.totalavailableCash_AED)
                    setTotalMarketValue_AED(dataValue.totalmarketValue_AED)

                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    };

    return (
        <div ref={ref} id="pdf-content">
            <div style={containerStyle} ref={ref} id="pdf-content">
                <header style={headerStyle}>
                    <MarginHeader clientAddressDetails={clientAddressDetails} fromDate={formattedFromDate}
                        toDate={formattedToDate} />
                </header>
                <hr />
                <main style={mainStyle}>
                    <NonMarginContent cashBalanceDetails={cashBalanceDetails} marginSummery={marginSummery} totalMarketValue_AED={totalMarketValue_AED} totalcashBalance_AED={totalcashBalance_AED} totalnetAssetValue_AED={totalnetAssetValue_AED} />

                </main>
                <footer style={footerStyle}>
                    <div style={{ lineHeight: "15px" }}>
                        <div>A Subsidiary of DUBAI INVESTMENTS</div>
                        <div>
                            {clientAddressDetails.building}, {clientAddressDetails.street}, {clientAddressDetails.citya}, {clientAddressDetails.countrya}.
                            Office {clientAddressDetails.officeno}, P.O. Box-{clientAddressDetails.postbox}, Tel: {clientAddressDetails.mobile},
                        </div>
                        <div>Al Mal Capital PSC is Registered with Federal Tax Authority with VAT Number {clientAddressDetails.trnno}</div>
                    </div>
                    <div className="pb-2 pt-3" style={{ lineHeight: "15px" }}>
                        <div>Al Mal Capital PSC is incorporated in Dubai UAE under CR 76761 as a Private Joint Stock Company with a paid-up share capital of AED 219.78 Million</div>
                        <div>(Al Mal Capital PSC is licensed and regulated by the Securities and Commodities Authorities, License No# 603022)</div>
                    </div>
                </footer>
            </div>
            <div >
                <div style={containerStyle} >
                    <footer style={mainStyle}>
                        <MarginTable marginDetails={marginDetails} clientAddressDetails={clientAddressDetails} fromDate={formattedFromDate}
                            toDate={formattedToDate} />
                    </footer>
                </div>
            </div>
        </div>
    )
})
export default StatementoffinancialholdingsPdf2;
